import BkPaReport from './BkPaReport';

export default BkPaReport;
